import React, { useState } from 'react';
import DataTableServerPaging from '../../../../../components/Table/DataTableServerPaging';
import { TableColumn } from 'react-data-table-component';
import { DetailPoleMRE, PoleMRE } from '../../../../basic/pole/models';
import { useAppDispatch, useAppSelector } from '../../../../../helpers/redux';
import { RootState } from '../../../../../app/store';
import {
    deleteMrePoleLog,
    getDetailPoleMRE,
    getPoleMREByJob,
    setShowAddMrePoleLogModal,
} from '../../../../basic/pole/pole.reducer';
import { JobID } from '../../jobDetail/models';
import { MREModel } from '../../../process/mre/models';
import { MdOutlineDeleteForever } from 'react-icons/md';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { customWarnOption } from 'helpers/alertLabel';
import DefaultModal from 'components/Modal/DefaultModal';
import AddMREPoleLogForm from './AddMREPoleLogForm';
import Button from 'components/Button/Button';

const DetailMREPoleTable = ({
    jobId = undefined,
}: DetailKatapultTableProps) => {
    const MySwal = withReactContent(Swal);
    const dispatch = useAppDispatch();

    const singleMRE = useAppSelector(
        (state: RootState) => state.processMRE.singleMRE ?? ({} as MREModel)
    );
    const pole = useAppSelector(
        (state: RootState) => state.pole.poleMREDetail ?? []
    );
    const poleRows = useAppSelector(
        (state: RootState) => state.pole.poleMREDetailRows ?? 0
    );
    const showAddMrePoleLogModal = useAppSelector(
        (state: RootState) => state.pole.showAddMrePoleLogModal ?? false
    );

    const columns: TableColumn<DetailPoleMRE>[] = [
        {
            name: '#',
            width: '60px',
            selector: (row) => row.index,
        },
        {
            name: 'Pole Seq',
            selector: (row) => row.seq,
            sortable: true,
        },
        {
            name: 'Pole No',
            selector: (row) => row.no ?? '-',
            sortable: true,
        },
        {
            name: 'Pole Status',
            selector: (row) => row.status_name,
            sortable: true,
        },
        {
            name: 'MRE',
            selector: (row) => row.employee_mre_name,
            sortable: true,
        },
        // {
        //     name: 'QC MRE',
        //     selector: (row) => row.employee_mre_qc_name,
        //     sortable: true,
        // },
        {
            name: 'MRE Type',
            selector: (row) => row.type,
            sortable: true,
        },
        {
            name: 'Action',
            width: '220px',
            cell: (row) => (
                <>
                    <button onClick={() => onDeleteClicked(row.id)}>
                        <MdOutlineDeleteForever className="mr-2 text-2xl text-secondary-color" />
                    </button>
                </>
            ),
        },
    ];

    const handlePagingChange = (rowsPerPage: number, page: number) => {
        dispatch(
            getDetailPoleMRE({
                job_id: jobId as string,
                skip: rowsPerPage * (page - 1),
                take: rowsPerPage,
            })
        );
    };

    const onDeleteClicked = (id: string) => {
        MySwal.fire(
            customWarnOption(
                'Remove MRE Pole Assign Log',
                'Are you sure you want to delete this pole assign log?'
            )
        ).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteMrePoleLog(id));
            }
        });
    };

    const closeModal = () => {
        dispatch(setShowAddMrePoleLogModal(false));
    };

    return (
        <div>
            <div className="flex justify-items-center">
                <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                    MRE - {singleMRE.number_job}
                </h1>
                <Button
                    title="Add MRE Pole Log"
                    type="button"
                    onClick={() => dispatch(setShowAddMrePoleLogModal(true))}
                />
            </div>
            <div className="main-data-grid mt-5">
                <DataTableServerPaging
                    columns={columns}
                    data={pole}
                    rows={poleRows}
                    handlePagingChange={handlePagingChange}
                />
            </div>
            <DefaultModal
                title={`Add MRE Pole Log`}
                show={showAddMrePoleLogModal}
                onClose={closeModal}
                body={<AddMREPoleLogForm />}
            />
        </div>
    );
};

export interface DetailKatapultTableProps {
    jobId?: string;
}

export default DetailMREPoleTable;
